import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import './newCard.css';
import { faDownload } from "@fortawesome/free-solid-svg-icons";
interface NewCardProps {
  title: string;
  mainValue: number;
  subValues: { label: string; value: number;type: string; }[];
  backgroundColor: string;
  icon?: any; 
  width?: string;   
  height?: string;  
  handleValueClick: (type: string,title: string, subLabel: string) => void;
}

const NewCard: React.FC<NewCardProps> = ({
  title,
  mainValue,
  subValues,
  backgroundColor,
  icon = faFile, 
  width='280px',
  height='160px',
  handleValueClick,
}) => {
  return (
    <div
      className='col-4'
      style={{
        backgroundColor,
        padding: '10px',
        borderRadius: '5px',
        margin: '10px',
        color: 'white',
        width,
        height,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className='newCard-logo'>
          <FontAwesomeIcon icon={icon} size="3x" />
        </div>
        <div className='newCard-headLabel'>
          <h6>{title}</h6>
          <div className='newCard-headValue'>
            <h6>{mainValue}{" "}
            </h6>
            {/* <FontAwesomeIcon icon={faDownload} /> */}
          </div>
        </div>
      </div>

      <div className='mainSub-Label' style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', marginTop:'20px' }}>
        {subValues.map((sub, index) => (
          <div key={index}  onClick={() => handleValueClick(sub.type,title,sub.label)} style={{ cursor: 'pointer', marginTop:'20px',marginLeft:'5px'  }}>
            <div className='newCard-subLabel'>
              <span>{sub.label}{"      "}</span> 
            </div>
            <div className='newCard-subValue'>
            <span> 
          {sub.value}{"     "}
          <FontAwesomeIcon icon={faDownload} />
        </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewCard;
